import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Row, Col, Button, Spinner } from "reactstrap"
import "../../newcomponents/index.css"
import { Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import OrganizationActionDropDown from "../../components/CommonForBoth/DropDowns/OrganizationActionDropDown"
import UserActionDropDown from "../../components/CommonForBoth/DropDowns/UserActionDropDown"
import axios from "axios"
import config from "../../config/config"
import { setBreadcrumbItems } from "../../store/actions"
import Select from "react-select"
import SnackbarComponent from "components/SnackBar"
import PrimaryButton from "newcomponents/primary-button"
import AddIcon from "@mui/icons-material/Add"
import SearchIcon from "@mui/icons-material/Search"

const Organizations = props => {
  document.title = "Offices | Reputation Management"

  const [users, setUsers] = useState(null)
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState(null)
  const [success, setSuccess] = useState(null)
  const [activeTab, setActiveTab] = useState("organizations")
  const [searchTerm, setSearchTerm] = useState("")
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const mode = useSelector(state => state.Layout.layoutMode)
  const organizations = useSelector(
    state => state.organizationReducer.organizations,
  )
  const userData = useSelector(state => state.Login.userData)

  const breadcrumbItems = [
    { title: "Reputation Management", link: "/" },
    { title: "Organization Details", link: "#" },
  ]

  const navigate = useNavigate()

  useEffect(() => {
    props.setBreadcrumbItems("Offices", breadcrumbItems)
  }, [props, breadcrumbItems])

  const fetchUsers = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `${config.backendUrl}/organization/getOrganizationUsers`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setUsers(response.data.users)
      setLoading(false)
    } catch (err) {
      console.log(err)
      setErr("Error fetching users.")
    }
  }

  useEffect(() => {
    if (userData.role == "admin") {
      fetchUsers()
    }
  }, [])

  const redirectToCreatePage = () => {
    navigate("/user/create")
  }

  // Filter data based on search term (searches entire dataset)
  const filterData = (data, isUser = false) => {
    if (!searchTerm) return data
    const term = searchTerm.toLowerCase()
    return data?.filter(item => {
      if (isUser) {
        return (
          item?.firstName?.toLowerCase().includes(term) ||
          item?.lastName?.toLowerCase().includes(term) ||
          item?.email?.toLowerCase().includes(term) ||
          item?.role?.toLowerCase().includes(term)
        )
      } else {
        const org = item?.Organization || item
        return (
          org?.name?.toLowerCase().includes(term) ||
          org?.email?.toLowerCase().includes(term) ||
          org?.city?.toLowerCase().includes(term) ||
          org?.country?.toLowerCase().includes(term) ||
          org?.type?.toLowerCase().includes(term)
        )
      }
    })
  }

  // Pagination helpers
  const getCurrentItems = data => {
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    return data?.slice(indexOfFirstItem, indexOfLastItem) || []
  }

  const getTotalPages = data => Math.ceil((data?.length || 0) / itemsPerPage)

  // Prepare filtered + paginated data
  let filteredOrganizations = []
  let filteredUsers = []
  let currentOrganizations = []
  let currentUsers = []

  if (activeTab === "organizations") {
    filteredOrganizations = filterData(organizations, false)
    currentOrganizations = getCurrentItems(filteredOrganizations)
  } else if (activeTab === "users") {
    const allUsers = users?.filter(u => u.id !== userData.id)
    filteredUsers = filterData(allUsers, true)
    currentUsers = getCurrentItems(filteredUsers)
  }

  // Totals
  const totalOrganizations = filteredOrganizations?.length || 0
  const totalUsers = filteredUsers?.length || 0
  const totalPages =
    activeTab === "organizations"
      ? getTotalPages(filteredOrganizations)
      : getTotalPages(filteredUsers)

  // Reset to page 1 when switching tabs or searching
  useEffect(() => {
    setCurrentPage(1)
  }, [activeTab, searchTerm])

  // Pagination component
  const renderPagination = () => {
    const pages = []
    const maxPagesToShow = 5

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, "...", totalPages)
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 1, totalPages)
      } else {
        pages.push(1, "...", currentPage, "...", totalPages)
      }
    }

    const totalRecords =
      activeTab === "organizations" ? totalOrganizations : totalUsers

    return (
      <div
        style={{
          borderRadius: "12px 12px 12px 12px",
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "30px",
          padding: "20px",
          color: mode === "dark" ? "#9ca3af" : "#6b7280",
          fontSize: "14px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <span>Showing</span>
          <select
            value={itemsPerPage}
            onChange={e => {
              setItemsPerPage(Number(e.target.value))
              setCurrentPage(1)
            }}
            style={{
              padding: "6px 30px 6px 12px",
              border: `1px solid ${mode === "dark" ? "#3a4556" : "#d1d5db"}`,
              borderRadius: "6px",
              background: mode === "dark" ? "#1a2332" : "#fff",
              color: mode === "dark" ? "#fff" : "#000",
              fontSize: "14px",
              cursor: "pointer",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23666' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 8px center",
            }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
          <span>of {totalRecords} records</span>
        </div>
        <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
          <button
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
            style={{
              padding: "6px 10px",
              border: "none",
              background: "transparent",
              color:
                currentPage === 1
                  ? mode === "dark"
                    ? "#4b5563"
                    : "#d1d5db"
                  : mode === "dark"
                    ? "#9ca3af"
                    : "#6b7280",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              fontSize: "18px",
            }}
          >
            «
          </button>
          <button
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{
              padding: "6px 10px",
              border: "none",
              background: "transparent",
              color:
                currentPage === 1
                  ? mode === "dark"
                    ? "#4b5563"
                    : "#d1d5db"
                  : mode === "dark"
                    ? "#9ca3af"
                    : "#6b7280",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              fontSize: "18px",
            }}
          >
            ‹
          </button>
          {pages.map((page, index) =>
            page === "..." ? (
              <span
                key={`ellipsis-${index}`}
                style={{
                  padding: "6px 12px",
                  color: mode === "dark" ? "#9ca3af" : "#6b7280",
                }}
              >
                ...
              </span>
            ) : (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "6px 12px",
                  border: "none",
                  borderRadius: "6px",
                  background: currentPage === page ? "#2990DF" : "transparent",
                  color:
                    currentPage === page
                      ? "#fff"
                      : mode === "dark"
                        ? "#9ca3af"
                        : "#6b7280",
                  cursor: "pointer",
                  minWidth: "36px",
                  fontWeight: currentPage === page ? "600" : "400",
                }}
              >
                {page}
              </button>
            ),
          )}
          <button
            onClick={() =>
              setCurrentPage(prev => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            style={{
              padding: "6px 10px",
              border: "none",
              background: "transparent",
              color:
                currentPage === totalPages
                  ? mode === "dark"
                    ? "#4b5563"
                    : "#d1d5db"
                  : mode === "dark"
                    ? "#9ca3af"
                    : "#6b7280",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              fontSize: "18px",
            }}
          >
            ›
          </button>
          <button
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
            style={{
              padding: "6px 10px",
              border: "none",
              background: "transparent",
              color:
                currentPage === totalPages
                  ? mode === "dark"
                    ? "#4b5563"
                    : "#d1d5db"
                  : mode === "dark"
                    ? "#9ca3af"
                    : "#6b7280",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
              fontSize: "18px",
            }}
          >
            »
          </button>
        </div>
      </div>
    )
  }

  return (
    <React.Fragment>
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <div
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          marginTop: "0px",
          padding: "15px 20px",
          fontFamily: "Inter",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          color: mode === "dark" ? "#fff" : "#050409",
          fontWeight: "600",
          fontSize: "23px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <h1
          style={{
            fontWeight: "500",
            marginTop: "10px",
            fontSize: "24px",
          }}
        >
          Admin consoles
        </h1>
        {activeTab === "users" && (
          <PrimaryButton
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              fontWeight: "500",
              borderRadius: "8px",
              backgroundColor: "#2990DF",
              border: "none",
              color: "#fff",
              textTransform: "none",
            }}
            icon={<AddIcon />}
            onClick={activeTab === "users" ? redirectToCreatePage : () => {}}
          >
            Create New
          </PrimaryButton>
        )}
      </div>

      <div
        style={{
          backgroundColor: mode === "dark" ? "#252f40" : "#fff",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h2
          style={{
            fontWeight: "500",
            fontSize: "18px",
            color: mode === "dark" ? "#fff" : "#000",
          }}
        >
          Offices
        </h2>
        {/* Tabs and Search */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            borderBottom: `1px solid ${mode === "dark" ? "#3a4556" : "#e5e7eb"}`,
          }}
        >
          <div style={{ display: "flex", gap: "0px" }}>
            <button
              onClick={() => setActiveTab("organizations")}
              style={{
                padding: "12px 24px",
                background: "transparent",
                border: "none",
                borderBottom:
                  activeTab === "organizations"
                    ? mode === "dark"
                      ? "2px solid #fff"
                      : "2px solid #2990DF"
                    : "none",
                color:
                  activeTab === "organizations"
                    ? mode === "dark"
                      ? "#fff"
                      : "#2990DF"
                    : mode === "dark"
                      ? "#9ca3af"
                      : "#6b7280",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
                transition: "all 0.2s ease-in-out",
              }}
            >
              Organizations
            </button>
            {userData.role === "admin" && (
              <button
                onClick={() => setActiveTab("users")}
                style={{
                  padding: "12px 24px",
                  background: "transparent",
                  border: "none",
                  borderBottom:
                    activeTab === "users"
                      ? mode === "dark"
                        ? "2px solid #fff"
                        : "2px solid #2990DF"
                      : "none",
                  color:
                    activeTab === "users"
                      ? mode === "dark"
                        ? "#fff"
                        : "#2990DF"
                      : mode === "dark"
                        ? "#9ca3af"
                        : "#6b7280",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                Users
              </button>
            )}
          </div>
          <div
            style={{
              position: "relative",
              width: "250px",
            }}
          >
            <SearchIcon
              style={{
                position: "absolute",
                left: "12px",
                top: "50%",
                transform: "translateY(-50%)",
                color: mode === "dark" ? "#9ca3af" : "#9ca3af",
                fontSize: "20px",
              }}
            />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 12px 8px 40px",
                borderRadius: "8px",
                border: `1px solid ${mode === "dark" ? "#3a4556" : "#e5e7eb"}`,
                background: mode === "dark" ? "#1a2332" : "#fff",
                color: mode === "dark" ? "#fff" : "#000",
                fontSize: "14px",
                outline: "none",
              }}
            />
          </div>
        </div>

        {/* Organizations Table */}
        {activeTab === "organizations" && (
          <>
            <div className="table-responsive">
              <Table
                className="table mb-0 table-transparent"
                style={{
                  width: "100%",
                }}
              >
                <thead>
                  <tr
                    style={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      color: mode === "dark" ? "#9ca3af" : "#6b7280",
                      borderBottom: `1px solid ${mode === "dark" ? "#3a4556" : "#e5e7eb"}`,
                    }}
                  >
                    <th style={{ padding: "12px", fontWeight: "600" }}>#</th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>NAME</th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      ADDRESS
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>TYPE</th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      CITY - COUNTRY
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      EMAIL
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      CONTACT
                    </th>
                    {userData.role === "admin" && (
                      <th style={{ padding: "12px", fontWeight: "600" }}>
                        ACTION
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {currentOrganizations.map((org, index) => (
                    <tr
                      key={org.Organization.id}
                      style={{
                        borderBottom: `1px solid ${mode === "dark" ? "#3a4556" : "#e5e7eb"}`,
                        color: mode === "dark" ? "#fff" : "#000",
                      }}
                    >
                      <td style={{ padding: "16px" }}>
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td style={{ padding: "16px", fontWeight: "600" }}>
                        {org.Organization.name}
                      </td>
                      <td style={{ padding: "16px" }}>
                        {org.Organization.address}
                      </td>
                      <td style={{ padding: "16px" }}>
                        {org.Organization.type}
                      </td>
                      <td style={{ padding: "16px" }}>
                        {org.Organization.city}, {org.Organization.country}
                      </td>
                      <td style={{ padding: "16px" }}>
                        {org.Organization.email}
                      </td>
                      <td style={{ padding: "16px" }}>
                        {org.Organization.contact}
                      </td>
                      {userData.role === "admin" && (
                        <td style={{ padding: "16px" }}>
                          <OrganizationActionDropDown
                            id={org.Organization.id}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        )}

        {/* Users Table */}
        {activeTab === "users" && userData.role === "admin" && (
          <>
            <div style={{ overflowX: "visible" }}>
              <Table
                className="table mb-0 table-transparent"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr
                    style={{
                      textTransform: "uppercase",
                      fontSize: "12px",
                      color: mode === "dark" ? "#9ca3af" : "#6b7280",
                      borderBottom: `1px solid ${mode === "dark" ? "#3a4556" : "#e5e7eb"}`,
                    }}
                  >
                    <th style={{ padding: "12px", fontWeight: "600" }}>#</th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      AVATAR
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      FIRST NAME
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      LAST NAME
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      EMAIL
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>ROLE</th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      ASSIGNED ORGANIZATION
                    </th>
                    <th style={{ padding: "12px", fontWeight: "600" }}>
                      ACTIONS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="8">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            height: "200px",
                            width: "100%",
                            backgroundColor: "transparent",
                          }}
                        >
                          <Spinner size="lg" color="primary" />
                        </div>
                      </td>
                    </tr>
                  ) : (
                    currentUsers?.map((user, index) => (
                      <tr
                        key={user.id}
                        style={{
                          borderBottom: `1px solid ${mode === "dark" ? "#3a4556" : "#e5e7eb"}`,
                          color: mode === "dark" ? "#fff" : "#000",
                        }}
                      >
                        <td style={{ padding: "16px" }}>
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </td>
                        <td style={{ padding: "16px" }}>
                          {user?.avatar ? (
                            <img
                              src={user.avatar}
                              alt="avatar"
                              style={{
                                width: "32px",
                                height: "32px",
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td style={{ padding: "16px", fontWeight: "600" }}>
                          {user?.firstName || "N/A"}
                        </td>
                        <td style={{ padding: "16px" }}>
                          {user?.lastName || "N/A"}
                        </td>
                        <td style={{ padding: "16px" }}>
                          {user?.email || "N/A"}
                        </td>
                        <td style={{ padding: "16px" }}>
                          {user?.role || "N/A"}
                        </td>
                        <td style={{ padding: "16px", width: "25%" }}>
                          <Select
                            value={user?.OrganizationAssignments?.map(org => ({
                              value: org.Organization.id,
                              label: org.Organization.name,
                            }))}
                            isMulti
                            name=""
                            className="basic-multi-select"
                            classNamePrefix="select"
                            isDisabled
                          />
                        </td>
                        <td style={{ padding: "16px" }}>
                          <UserActionDropDown
                            id={user.id}
                            isActive={user.isActive}
                            fetchUsers={fetchUsers}
                            setErr={setErr}
                            setSuccess={setSuccess}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </div>
      {!loading && renderPagination()}
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Organizations)